import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { TimeFormat } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

import Tooltip from "../Tooltip";

export default function DefaultDateTimeTz({
  date,
  userDate,
  timezone,
  includeSeconds,
}: {
  date: Date;
  includeSeconds?: boolean;
  timezone: keyof typeof timeZoneMap;
  userDate: Date;
}) {
  const { userTimezone } = useTimezone();

  if (timezone === "system") {
    return (
      <span>
        <FormattedDate date={date} includeSeconds={includeSeconds} />
      </span>
    );
  }

  return (
    <div className="relative w-auto">
      <Tooltip
        text={
          <FormattedDate
            date={userDate}
            timezone={userTimezone}
            includeSeconds={includeSeconds}
          />
        }
        position="top"
        tooltipClassName="w-[200px] flex justify-center"
      >
        <span>
          <FormattedDate
            date={date}
            timezone={timezone}
            includeSeconds={includeSeconds}
          />
        </span>
      </Tooltip>
    </div>
  );
}

const FormattedDate = ({
  date,
  timezone,
  includeSeconds,
}: {
  date: Date;
  includeSeconds?: boolean;
  timezone?: Partial<keyof typeof timeZoneMap>;
}) => {
  const { getTimezone } = useTimezone();

  if (!dayjs(date).isValid()) {
    return <span></span>;
  }

  // Convert UTC time to specified timezone for display
  const effectiveTimezone = getTimezone(timezone);
  const format = includeSeconds
    ? TimeFormat.month_day_year_hour_minute_second_am_pm
    : TimeFormat.month_day_year_hour_minute_am_pm;

  const formatted =
    effectiveTimezone === "system"
      ? dayjs(date).format(format)
      : dayjs.utc(date).tz(effectiveTimezone).format(`${format} z`);

  return <span className="">{formatted}</span>;
};
